import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 16, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} viewBox='0 0 26 26' onClick={onClick} width={size} height={size} className={className} fill={fillColor}>
      <g>
        <path d='M11,3H1C0.4,3,0,3.4,0,4v2c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V4C12,3.4,11.6,3,11,3z' />
        <path d='m11,11h-10c-0.6,0-1,0.4-1,1v2c0,0.6 0.4,1 1,1h10c0.6,0 1-0.4 1-1v-2c0-0.6-0.4-1-1-1z' />
        <path d='m11,19h-10c-0.6,0-1,0.4-1,1v2c0,0.6 0.4,1 1,1h10c0.6,0 1-0.4 1-1v-2c0-0.6-0.4-1-1-1z' />
        <path d='m25.7,10.7l-1.4,1.4c-0.2,0.2-0.5,0.3-0.7,0.3-0.3,0-0.5-0.1-0.7-0.3l-2-2c-0.3-0.3-0.9-0.1-0.9,0.4v13.5c0,0.5-0.5,1-1,1h-2c-0.5,0-1-0.5-1-1v-22c0-0.3 0.1-0.5 0.3-0.7s0.5-0.3 0.7-0.3c0.3,0 0.5,0.1 0.7,0.3l8,8c0.2,0.2 0.3,0.4 0.3,0.7 0,0.3-0.1,0.5-0.3,0.7z' />
      </g>
    </svg>
  );
});

export default React.memo(Icon);
